import React, { useState, useEffect } from 'react';
import { 
  Plug, 
  Plus, 
  Search, 
  Filter, 
  Edit3, 
  Trash2, 
  Eye, 
  Save,
  RefreshCw,
  CheckCircle,
  AlertTriangle,
  X,
  Activity,
  Users,
  Calendar,
  FileText,
  Database,
  Server,
  Bell,
  Download,
  Upload,
  MoreHorizontal,
  ChevronDown,
  ChevronRight,
  Copy,
  TestTube,
  BarChart3,
  TrendingUp,
  PieChart,
  Timer,
  Zap,
  AlertCircle,
  CheckSquare,
  Square,
  Star,
  Award,
  TrendingDown,
  Percent,
  DollarSign,
  UserCheck,
  UserX,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Clock7,
  Clock8,
  Clock9,
  Clock10,
  Clock11,
  Clock12,
  Send,
  Paperclip,
  Image,
  Link,
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  List,
  Quote,
  Code,
  Palette,
  Type,
  Layout,
  Monitor,
  Smartphone,
  Tablet,
  Key,
  Lock,
  Unlock,
  Globe,
  Wifi,
  HardDrive,
  Cpu,
  Network,
  Mail,
  Phone,
  MapPin,
  Calendar as CalendarIcon,
  Clock,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  CloudSnow,
  Wind,
  Thermometer,
  Droplets,
  Gauge,
  Zap as ZapIcon,
  Battery,
  WifiOff,
  Signal,
  SignalZero,
  SignalLow,
  SignalMedium,
  SignalHigh,
  SignalMax,
  UserPlus,
  UserMinus,
  Settings as SettingsIcon,
  Home,
  Office,
  Factory,
  Store,
  School,
  Hospital,
  Bank,
  Briefcase,
  GraduationCap,
  Stethoscope,
  CreditCard,
  ShoppingCart,
  BookOpen,
  Heart,
  DollarSign as DollarSignIcon,
  Crown,
  Badge,
  Award as AwardIcon,
  Medal,
  Trophy,
  Certificate,
  Diploma,
  GraduationCap as GraduationCapIcon,
  UserCog,
  UserShield,
  UserCheck as UserCheckIcon,
  UserX as UserXIcon,
  UserPlus as UserPlusIcon,
  UserMinus as UserMinusIcon,
  UserEdit,
  UserSettings,
  UserSearch,
  UserClock,
  UserStar,
  UserHeart,
  UserSmile,
  UserFrown,
  UserMeh,
  UserCheck2,
  UserX2,
  UserPlus2,
  UserMinus2,
  UserEdit2,
  UserSettings2,
  UserSearch2,
  UserClock2,
  UserStar2,
  UserHeart2,
  UserSmile2,
  UserFrown2,
  UserMeh2,
  Archive,
  ArchiveRestore,
  ArchiveX,
  ArchiveCheck,
  ArchivePlus,
  ArchiveMinus,
  ArchiveEdit,
  ArchiveSettings,
  ArchiveSearch,
  ArchiveClock,
  ArchiveStar,
  ArchiveHeart,
  ArchiveSmile,
  ArchiveFrown,
  ArchiveMeh,
  ArchiveCheck2,
  ArchiveX2,
  ArchivePlus2,
  ArchiveMinus2,
  ArchiveEdit2,
  ArchiveSettings2,
  ArchiveSearch2,
  ArchiveClock2,
  ArchiveStar2,
  ArchiveHeart2,
  ArchiveSmile2,
  ArchiveFrown2,
  ArchiveMeh2
} from 'lucide-react';
import MockDataService from '../../services/MockDataService';

const SystemIntegration = () => {
  const [integrationData, setIntegrationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('integrations');
  const [showIntegrationForm, setShowIntegrationForm] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [expandedIntegrations, setExpandedIntegrations] = useState(new Set());
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const fetchIntegrationData = async () => {
      try {
        setLoading(true);
        const response = await MockDataService.getSystemIntegration();
        if (response.success) {
          setIntegrationData(response.data);
        } else {
          setError('Failed to load system integration data');
        }
      } catch (err) {
        setError('Error loading system integration data');
        console.error('System integration data error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchIntegrationData();
  }, []);

  const handleCreateIntegration = () => {
    setSelectedIntegration(null);
    setShowIntegrationForm(true);
  };

  const handleEditIntegration = (integration) => {
    setSelectedIntegration(integration);
    setShowIntegrationForm(true);
  };

  const handleCloseIntegrationForm = () => {
    setShowIntegrationForm(false);
    setSelectedIntegration(null);
    setHasUnsavedChanges(false);
  };

  const handleSubmitIntegration = (integrationData) => {
    //console.log('Submitting integration:', integrationData);
    setShowIntegrationForm(false);
    setSelectedIntegration(null);
    setHasUnsavedChanges(false);
  };

  const handleDeleteIntegration = (integrationId) => {
    if (window.confirm('Are you sure you want to delete this integration?')) {
      //console.log('Deleting integration:', integrationId);
    }
  };

  const handleTestIntegration = (integrationId) => {
    //console.log('Testing integration:', integrationId);
  };

  const handleSyncIntegration = (integrationId) => {
    //console.log('Syncing integration:', integrationId);
  };

  const toggleIntegrationExpansion = (integrationId) => {
    const newExpanded = new Set(expandedIntegrations);
    if (newExpanded.has(integrationId)) {
      newExpanded.delete(integrationId);
    } else {
      newExpanded.add(integrationId);
    }
    setExpandedIntegrations(newExpanded);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading system integration...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <p className="text-red-600 dark:text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!integrationData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">No system integration data available</p>
        </div>
      </div>
    );
  }

  const { 
    systemIntegration, 
    integrationStats, 
    recentActivity, 
    integrationAnalytics
  } = integrationData;

  const { integrations, webhooks, apiKeys, integrationTemplates } = systemIntegration;

  const tabs = [
    { id: 'integrations', label: 'Integrations', icon: Plug },
    { id: 'webhooks', label: 'Webhooks', icon: Zap },
    { id: 'apikeys', label: 'API Keys', icon: Key },
    { id: 'templates', label: 'Templates', icon: FileText }
  ];

  const getTypeIcon = (type) => {
    switch (type) {
      case 'authentication': return Lock;
      case 'notification': return Bell;
      case 'crm': return Users;
      case 'project_management': return Briefcase;
      default: return Plug;
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'authentication': return 'blue';
      case 'notification': return 'green';
      case 'crm': return 'orange';
      case 'project_management': return 'purple';
      default: return 'blue';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-green-600 dark:text-green-400';
      case 'inactive': return 'text-gray-600 dark:text-gray-400';
      case 'error': return 'text-red-600 dark:text-red-400';
      default: return 'text-gray-600 dark:text-gray-400';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return CheckCircle;
      case 'inactive': return X;
      case 'error': return AlertTriangle;
      default: return X;
    }
  };

  const getHealthColor = (health) => {
    switch (health) {
      case 'healthy': return 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200';
      case 'warning': return 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200';
      case 'error': return 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200';
      default: return 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200';
    }
  };

  const filteredIntegrations = integrations.filter(integration => {
    const matchesSearch = integration.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         integration.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = filterStatus === 'all' || integration.status === filterStatus;
    const matchesType = filterType === 'all' || integration.type === filterType;
    return matchesSearch && matchesStatus && matchesType;
  });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Plug className="h-8 w-8 text-blue-600 dark:text-blue-400" />
              <div>
                <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                  System Integration
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Manage third-party integrations and API connections
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              {hasUnsavedChanges && (
                <div className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900 rounded-md">
                  <AlertTriangle className="h-4 w-4" />
                  <span>Unsaved Changes</span>
                </div>
              )}
              <button className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                <Download className="h-4 w-4" />
                <span>Export</span>
              </button>
              <button
                onClick={handleCreateIntegration}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                <Plus className="h-4 w-4" />
                <span>Add Integration</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Integration Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <Plug className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Integrations</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{integrationStats.totalIntegrations}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-green-100 dark:bg-green-900 rounded-lg">
                <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{integrationStats.activeIntegrations}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg">
                <Zap className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Webhooks</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{integrationStats.totalWebhooks}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-orange-100 dark:bg-orange-900 rounded-lg">
                <TrendingUp className="h-6 w-6 text-orange-600 dark:text-orange-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Success Rate</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{integrationStats.syncSuccessRate}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Integration</h3>
                <nav className="space-y-2">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`w-full flex items-center space-x-3 px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                          activeTab === tab.id
                            ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300'
                            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                        }`}
                      >
                        <Icon className="h-4 w-4" />
                        <span>{tab.label}</span>
                      </button>
                    );
                  })}
                </nav>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              {/* Integrations Tab */}
              {activeTab === 'integrations' && (
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Integrations</h2>
                    <div className="flex items-center space-x-2">
                      <button className="flex items-center space-x-1 px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
                        <RefreshCw className="h-4 w-4" />
                        <span>Refresh</span>
                      </button>
                    </div>
                  </div>

                  {/* Search and Filters */}
                  <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <div className="flex-1">
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search integrations..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <select
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="error">Error</option>
                      </select>
                      <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Types</option>
                        <option value="authentication">Authentication</option>
                        <option value="notification">Notification</option>
                        <option value="crm">CRM</option>
                        <option value="project_management">Project Management</option>
                      </select>
                    </div>
                  </div>

                  {/* Integrations List */}
                  <div className="space-y-3">
                    {filteredIntegrations.map((integration) => {
                      const TypeIcon = getTypeIcon(integration.type);
                      const StatusIcon = getStatusIcon(integration.status);
                      const isExpanded = expandedIntegrations.has(integration.id);
                      
                      return (
                        <div key={integration.id} className="border border-gray-200 dark:border-gray-700 rounded-lg">
                          <div className="flex items-center justify-between p-4">
                            <div className="flex items-center space-x-4">
                              <button
                                onClick={() => toggleIntegrationExpansion(integration.id)}
                                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                              >
                                {isExpanded ? (
                                  <ChevronDown className="h-4 w-4 text-gray-400" />
                                ) : (
                                  <ChevronRight className="h-4 w-4 text-gray-400" />
                                )}
                              </button>
                              <div className={`p-2 bg-${getTypeColor(integration.type)}-100 dark:bg-${getTypeColor(integration.type)}-900 rounded-lg`}>
                                <TypeIcon className={`h-4 w-4 text-${getTypeColor(integration.type)}-600 dark:text-${getTypeColor(integration.type)}-400`} />
                              </div>
                              <div className="flex-1">
                                <div className="flex items-center space-x-2 mb-1">
                                  <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">{integration.name}</h3>
                                  <span className="text-xs text-gray-500 dark:text-gray-400">{integration.provider}</span>
                                </div>
                                <p className="text-sm text-gray-600 dark:text-gray-400">{integration.description}</p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <StatusIcon className={`h-4 w-4 ${getStatusColor(integration.status)}`} />
                              <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                                integration.status === 'active' ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' :
                                integration.status === 'inactive' ? 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200' :
                                'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200'
                              }`}>
                                {integration.status}
                              </span>
                              <span className={`text-xs font-medium px-2 py-1 rounded-full ${getHealthColor(integration.health)}`}>
                                {integration.health}
                              </span>
                              <div className="flex items-center space-x-1">
                                <button
                                  onClick={() => handleTestIntegration(integration.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                  title="Test Integration"
                                >
                                  <TestTube className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleSyncIntegration(integration.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                  title="Sync Integration"
                                >
                                  <RefreshCw className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleEditIntegration(integration)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Edit3 className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleDeleteIntegration(integration.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Trash2 className="h-4 w-4 text-gray-400" />
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Expanded Integration Details */}
                          {isExpanded && (
                            <div className="border-t border-gray-200 dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-700">
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Integration Details</h4>
                                  <div className="space-y-2">
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Version:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{integration.version}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Last Sync:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{new Date(integration.lastSync).toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Next Sync:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{new Date(integration.nextSync).toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Sync Frequency:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{integration.syncFrequency}</span>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Permissions</h4>
                                  <div className="space-y-1">
                                    {integration.permissions.map((permission, index) => (
                                      <div key={index} className="flex items-center space-x-2 text-sm">
                                        <CheckCircle className="h-3 w-3 text-green-500" />
                                        <span className="text-gray-700 dark:text-gray-300">{permission}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              {integration.lastError && (
                                <div className="mt-4 p-3 bg-red-100 dark:bg-red-900 rounded-md">
                                  <p className="text-sm text-red-800 dark:text-red-200">
                                    <strong>Last Error:</strong> {integration.lastError}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Other tabs would be implemented similarly */}
              {activeTab === 'webhooks' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Webhooks</h2>
                  <p className="text-gray-600 dark:text-gray-400">Webhook management coming soon...</p>
                </div>
              )}

              {activeTab === 'apikeys' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">API Keys</h2>
                  <p className="text-gray-600 dark:text-gray-400">API key management coming soon...</p>
                </div>
              )}

              {activeTab === 'templates' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Integration Templates</h2>
                  <p className="text-gray-600 dark:text-gray-400">Integration templates coming soon...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Integration Form Modal */}
      {showIntegrationForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl mx-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {selectedIntegration ? 'Edit Integration' : 'Add New Integration'}
              </h3>
              <button
                onClick={handleCloseIntegrationForm}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Integration Name
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedIntegration?.name || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter integration name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Integration Type
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                    <option value="authentication">Authentication</option>
                    <option value="notification">Notification</option>
                    <option value="crm">CRM</option>
                    <option value="project_management">Project Management</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Description
                </label>
                <textarea
                  rows={3}
                  defaultValue={selectedIntegration?.description || ''}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  placeholder="Enter integration description"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Provider
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedIntegration?.provider || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter provider name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Version
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedIntegration?.version || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter version"
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end space-x-3 mt-6">
              <button
                onClick={handleCloseIntegrationForm}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => handleSubmitIntegration({})}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                {selectedIntegration ? 'Update Integration' : 'Add Integration'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemIntegration;
